import HttpStatus from 'components/Common/HttpStatus'
import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import Error500Page from 'components/Pages/Error500Page'
import useMerchandiseOffer from 'hooks/Merchandise/useMerchandiseOffer'
import { useRouteMatch } from 'react-router'
import MerchandiseOfferPageContent from './MerchandiseOfferPageContent'
import MerchandiseSearchPageNoResults from '../MerchandiseSearchPage/MerchandiseSearchPageNoResults'

function MerchandiseOfferPage() {
  const { offerId } = useRouteMatch<{ offerId: string, slug: string }>().params

  const [offer, _, offerError] = useMerchandiseOffer(offerId)

  if (offerError) {
    if (offerError.status === 404 || offerError.status === 400) {
      // Show no results page for invalid/not found offer IDs
      return <HttpStatus code={404}>
        <MerchandiseSearchPageNoResults
          category={undefined}
          brand={undefined}
          search={undefined}
        />
      </HttpStatus>
    } else {
      return <HttpStatus code={500}>
        <Error500Page error={offerError} />
      </HttpStatus>
    }
  }

  if (!offer) {
    return <LoadingIndicator />
  }

  return <MerchandiseOfferPageContent key={offerId} offer={offer} />
}

export default MerchandiseOfferPage
